import { createClient } from '@sanity/client';
import { createImageUrlBuilder } from '@sanity/image-url';

export const client = createClient({
  projectId: '7aikkr0k',
  dataset: 'production',
  apiVersion: '2024-05-09',
  useCdn: true, // `false` if you want to ensure fresh data
});

const builder = createImageUrlBuilder(client);

// Helper function to easily get image URLs
export function urlFor(source) {
  return builder.image(source);
}
